/**
 * Port Management Helper Utilities
 */

/** Days since last message thresholds (matches keep-alive worker) */
export const EXPIRING_MIN_DAYS = 80;
export const EXPIRING_MAX_DAYS = 89;
export const DEAD_MIN_DAYS = 90;

/**
 * Strip non-digits from phone numbers
 */
export const digits = (s) => String(s || '').replace(/\D/g, '');

/**
 * Calculate whole days since last message was sent (null if never sent)
 */
export function getDaysSinceLastMessage(lastMessageSent) {
  if (!lastMessageSent) return null;

  const lastMessageDate = new Date(lastMessageSent);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  lastMessageDate.setHours(0, 0, 0, 0);

  return Math.floor((today - lastMessageDate) / (1000 * 60 * 60 * 24));
}

/**
 * Classify a port by SIM lifecycle based on last_message_sent
 * @returns {'unused' | 'expiring' | 'dead' | 'healthy'}
 */
export function getPortLifecycleCategory(port) {
  const days = getDaysSinceLastMessage(port?.last_message_sent);
  if (days === null) return 'unused';
  if (days >= DEAD_MIN_DAYS) return 'dead';
  if (days >= EXPIRING_MIN_DAYS) return 'expiring';
  return 'healthy';
}

/**
 * Render gateway name from port or gateways list
 */
export const renderGatewayName = (port, gateways = []) => {
  if (port.gateway && port.gateway.name) return port.gateway.name;
  const gw = gateways.find(
    (g) => String(g.id) === String(port.gateway_id)
  );
  if (gw && gw.name) return gw.name;
  if (port.gateway_id == null || port.gateway_id === '') return '—';
  return port.gateway_id;
};

/**
 * Derive a clean "gw-<n>" label from a port's gateway fields
 */
export const deriveGatewayLabel = (port) => {
  if (!port) return undefined;
  if (port.gateway_id != null) return `gw-${port.gateway_id}`;
  if (port.gateway?.id != null) return `gw-${port.gateway.id}`;
  return undefined;
};

/**
 * Parse error detail from API response
 */
export const parseErrorDetail = (detail) => {
  if (Array.isArray(detail)) {
    return detail.map((d) => d.msg).join(', ');
  } else if (typeof detail === 'object') {
    return JSON.stringify(detail);
  } else {
    return detail || 'Failed to save port';
  }
};


